import { getContactsData } from 'services/api/contacts';
import { IContactsResponse } from 'types/api-responses';
import { useData } from './useData';

export const useContactsData = () =>
  useData<IContactsResponse['data']>(getContactsData);
